function NotificationList({
    notifications
}) {
    return (
        <div className='row NotificationList'>
            <div className='col-12'>
                {notifications && notifications.map(notification => (
                    <div key={notification.id} className='row mb-3 element px-2 pt-3'>
                        <div className='col-3 d-flex align-items-center mb-3'>
                            <p className={'pt-3' + (notification.unread ? 'fw-bold' : '')}>{notification.title}</p>
                        </div>
                        <div className='col-9 d-flex align-items-center'>
                            <p>{notification.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default NotificationList;